import { render } from "./GenreFilter.vue?vue&type=template&id=59bfbf13&scoped=true"
import script from "./GenreFilter.vue?vue&type=script&lang=js"
export * from "./GenreFilter.vue?vue&type=script&lang=js"

import "./GenreFilter.vue?vue&type=style&index=0&id=59bfbf13&scoped=true&lang=less"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bfbf13"]])

export default __exports__